import { createFileRoute } from '@tanstack/react-router'

import { PricePage } from '#/modules/pricing/price-page'

export const Route = createFileRoute('/_shell/messaging-prices/$priceId')({
  component: function PriceRoute() {
    const { priceId } = Route.useParams()
    return <PricePage priceId={priceId} />
  },
})
